import { Link } from 'react-router-dom';
import { externalLinkProps, links, routes } from '../../config/links';
import RequestDemoButton from '../RequestDemoButton/RequestDemoButton';
import styles from './CTAButtons.module.css';

interface CTAButtonsProps {
  size?: 'md' | 'lg';
  layout?: 'row' | 'column';
  className?: string;
  showAdmin?: boolean;
  showCustomerApp?: boolean;
}

function CTAButtons({
  size = 'md',
  layout = 'row',
  className = '',
  showAdmin = true,
  showCustomerApp = false,
}: CTAButtonsProps) {
  const classes = [styles.group, styles[size], styles[layout], className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <RequestDemoButton size={size} />
      {showAdmin && (
        <a
          href={links.adminUrl}
          className={styles.secondary}
          {...externalLinkProps}
          aria-label="Open the ONI admin dashboard to log in"
        >
          Login
        </a>
      )}
      {showCustomerApp && (
        <a
          href={links.customerUrl}
          className={styles.secondary}
          {...externalLinkProps}
          aria-label="See the fan ordering experience"
        >
          See Fan Experience
        </a>
      )}
    </div>
  );
}

export function SectionDemoLink({ className = '' }: { className?: string }) {
  return (
    <Link to={routes.requestDemo} className={[styles.sectionLink, className].filter(Boolean).join(' ')}>
      Request a demo →
    </Link>
  );
}

export function LearnMoreLink({ to, label, className = '' }: { to: string; label: string; className?: string }) {
  return (
    <Link to={to} className={[styles.sectionLink, className].filter(Boolean).join(' ')}>
      {label}
    </Link>
  );
}

export default CTAButtons;
